import { render, staticRenderFns } from "./LivekitMeeting.vue?vue&type=template&id=c862fd08&scoped=true"
import script from "./LivekitMeeting.vue?vue&type=script&lang=js"
export * from "./LivekitMeeting.vue?vue&type=script&lang=js"
import style0 from "./LivekitMeeting.vue?vue&type=style&index=0&id=c862fd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c862fd08",
  null
  
)

export default component.exports